module.exports = __webpack_public_path__ + "static/15invgde-bfa89b14d0398b2de43ec142349f12e6.gif";